if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollTo({ left: activeMedia.offsetLeft, behavior: 'instant' });
        }

        this.syncModalSlider(activeMedia);

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      syncModalSlider(activeMedia) {
        const slider = this.querySelector('[id^="ModalSlider-"]');
        if (!slider || !activeMedia) return;

        const content = slider.querySelector('.product-media-modal__content');
        if (!content) return;

        const slides = Array.from(content.querySelectorAll(':scope > *'));
        const index = slides.indexOf(activeMedia);
        if (index < 0) return;

        const counterCurrent = slider.querySelector('.modal-counter--current');
        if (counterCurrent) counterCurrent.textContent = index + 1;

        const thumbs = slider.querySelectorAll('.product-media-modal__thumbnail-item');
        thumbs.forEach((t) => t.classList.remove('is-active'));
        const activeThumb = slider.querySelector(`[data-modal-thumb-index="${index}"]`);
        if (activeThumb) activeThumb.classList.add('is-active');
      }
    }
  );
}